export const shareLink = (objectId: string, objectType: string) => {
  return `/share/${objectType === 'skillSet' ? 'skill_set' : objectType}/${objectId}`
}
